import React from 'react';
import { FormattedMessage } from 'react-intl';
import { IconWarning } from '@americanexpress/dls-icons';
import { Heading, Layout } from '@americanexpress/dls-react';

export default function GridError(props) {
  const locale = props.locale;
  return (
    <Layout variant="card" innerContainerClassName="pad-2 pad-3-lg-up">
      <div className="flex flex-column flex-align-center">
        <IconWarning size="xl" color="critical" isFilled={true} />
        {(locale !== 'en-HK' && locale !== 'zh-HK') && (
        <Heading level={2} variant="sans-medium-bold" className="margin-2-t margin-3-t-lg-up">
          <FormattedMessage id="errors.load.sorry" defaultMessage="We're Sorry" />
        </Heading>
        )}
        <p className="margin-2-b">
          <FormattedMessage id="errors.load.unable-to-load" defaultMessage="We're unable to load this page at this time. Please try again later." />
        </p>
        <hr />
        <p className="margin-2-t">
          <FormattedMessage id="errors.load.need-assistance" defaultMessage="If you need immediate assistance, please call the number on the back of your Card." />
        </p>
      </div>
    </Layout>
  );
}
